var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: {
          "has-line": "",
          subtitle:
            "Las expectativas añadidas estarán disponibles para seleccionar al momento\n    de crear una sección de preguntas.",
          "subtitle-class": "text-gray",
          "subtitle-icon": "fal fa-exclamation-circle",
          title: "Configuración de Expectativas"
        }
      }),
      _c("div", { staticClass: "mt-4 panel-content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-3 col-md-12 boder" },
            [
              _c("validation-observer", { ref: "formValidator" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 mb-4" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(" Nombre de la Expectativa: ")
                                ]),
                                _c("custom-drop-down", {
                                  attrs: {
                                    "custom-error-msg": "El campo es requerido",
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    options: _vm.availableAnswers,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.model.answer,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "answer", $$v)
                                    },
                                    expression: "model.answer"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm.isOther
                        ? _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        staticClass: "mt-3",
                                        attrs: {
                                          "custom-error-msg":
                                            "El campo es requerido",
                                          error: errors[0],
                                          placeholder: "Expectativa"
                                        },
                                        model: {
                                          value: _vm.model.other,
                                          callback: function($$v) {
                                            _vm.$set(_vm.model, "other", $$v)
                                          },
                                          expression: "model.other"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              124575573
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mb-4" },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(" Seleccione Color: ")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex justify-content-between",
                          staticStyle: {
                            padding: "6px",
                            background: "white",
                            "border-radius": "4px",
                            "align-items": "center",
                            gap: "12px",
                            display: "inline-flex"
                          }
                        },
                        _vm._l(_vm.colors, function(item) {
                          return _c("color", {
                            key: item.id,
                            attrs: {
                              color: item.id,
                              disabled: item.disabled,
                              selected: item.selected
                            },
                            on: { selected: _vm.onColorSelected }
                          })
                        }),
                        1
                      ),
                      _vm.showError && !this.model.color
                        ? _c("custom-error", {
                            attrs: {
                              message: "El campo es requerido",
                              variant: "no-border mt-1"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  [
                    _c("action-button", {
                      staticClass: "mt-3",
                      attrs: {
                        disabled: !_vm.canAddAnswer,
                        i: "fas fa-file-plus",
                        text: "Añadir Expectativa",
                        variant: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.add()
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "col-lg-9 col-md-12" }, [
            _c("div", { staticClass: "text" }, [_vm._v(" Seleccionado(s): ")]),
            _c(
              "div",
              { staticClass: "answer-content" },
              _vm._l(_vm.input, function(answer, index) {
                return _c("chip", {
                  key: index,
                  attrs: { index: index, model: answer },
                  on: { delete: _vm.onDeleteHandler }
                })
              }),
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }